import { render, staticRenderFns } from "./DataBank.vue?vue&type=template&id=28f9e0f6&scoped=true&"
import script from "./DataBank.vue?vue&type=script&lang=js&"
export * from "./DataBank.vue?vue&type=script&lang=js&"
import style0 from "./DataBank.vue?vue&type=style&index=0&id=28f9e0f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f9e0f6",
  null
  
)

export default component.exports